
import {
  // Card, CardHeader, CardContent, Collapse, Divider, IconButton,
  Box, Typography
} from '@mui/material';
import React from 'react'
// import { getRandomStr } from '../../../helpers';
import { getChartSeriesColor } from '../../../utils';
// import Clipboard from '../../_common/Clipboard';
// import CloseFullscreenRoundedIcon from '@mui/icons-material/CloseFullscreenRounded';
import CommitRoundedIcon from '@mui/icons-material/CommitRounded';
import StopRoundedIcon from '@mui/icons-material/StopRounded';
import { getRandomStr } from '../../../helpers';
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
// import { styled } from '@mui/styles';

// const LightTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.arrow}`]: {
//     color: theme.palette.primary.main,
//   },
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.primary.main,
//     // color: 'rgba(0, 0, 0, 0.87)',
//     color: '#fff',
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//   },
// }));

const CollapseCard = ({ selectedInfo, section_code, chart_codes, handleClick, height, sx }) => {
  return (
    <>
      {/* <Collapse key={section_code} in={selectedInfo === section_code ? true : false}
        sx={{
          position: 'absolute', top: 0, width: '100%',
          '& svg': { width: '100%', height: "1.2rem !important" }
        }}
      >
        <Card sx={{ maxWidth: '100%', bgcolor: 'background.default', zIndex: 999, minHeight: height || '35vh', maxHeight: height || '35vh', boxShadow: 0, overflow: 'auto' }} className="opt-chart-s-title">
          <CardHeader
            sx={{ '& .MuiCardHeader-subheader': { fontSize: '.87rem' } }}
            subheader="Data series used in this chart."
            action={
              <IconButton aria-label="close-opt-chart" >
                <CloseFullscreenRoundedIcon sx={{ fontSize: '1.1rem' }} />
              </IconButton>
            }
          />
          <CardContent>
            {chart_codes?.series.map((d, i) => {
              return (
                <Box key={getRandomStr(3)} className="opt-chart-s" style={{ color: getChartSeriesColor(d, chart_codes?.currTheme.pallete[i]) }}>
                  <Divider textAlign="right" sx={{ textTransform: 'uppercase', fontSize: '.8rem', color: 'text.description' }}>{d.legend.label}</Divider>
                  <Clipboard
                    wrapperClass="opt-chart-s-formula"
                    value={d.yformula}
                    handleClick={handleClick(`COPIED  "${d.yformula}".`)}
                    chipBGcolor={getChartSeriesColor(d, chart_codes?.currTheme.pallete[i])}
                  />
                </Box>
              );
            })}
          </CardContent>
        </Card>
      </Collapse> */}

      <Box component="div" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', ...sx }}>
        {chart_codes?.series.map((d, i) => {
          return (
            d?.legend?.label && d?.legend?.label !== '' &&
            <Box key={getRandomStr(4)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1, mr: 1.5, '& svg': { mr: .7, width: '1em !important', fontSize: d?.type === 'bar' ? '1rem !important' : '1.1rem !important', color: getChartSeriesColor(d, chart_codes?.currTheme.pallete[i]) } }}>
              {d?.type === 'bar' ? <StopRoundedIcon /> : <CommitRoundedIcon />}
              <Typography variant="p" sx={{ fontSize: '.67rem', fontWeight: 600 }}>{d.legend.label}</Typography>
            </Box>
          );
        })}
      </Box>
    </>
  )
}

export default CollapseCard
